import { ContactTypeEnum } from '../enums';

export class CustomerEmployeeContactResult {
    public id: number;
    public contact: string;
    public contactTypeId: number | null;
    public contactTypeName: string;
    public contactTypeEnum: ContactTypeEnum = ContactTypeEnum.Other;
    public isDefault: boolean;
    public isDeleted: boolean;

    ///////////////////// front-end ////////////////////
    public contactIsInvalid: boolean;
    public contactTypeIdIsInvalid: boolean;

    constructor() {
        this.id = 0;
        this.contact = '';
        this.isDefault = false;
        this.isDeleted = false;
        this.contactTypeId = null;
        this.contactTypeName = '';
        this.contactIsInvalid = false;
        this.contactTypeIdIsInvalid = false;
    }
}